import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';

import { FsProgressModule } from '@firestitch/progress';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { SideNavModule } from '@libs/layouts/side-nav';
import { CardModule } from '@libs/layouts/card';

import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [
        AppComponent,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ], imports: [AppRoutingModule,
        BrowserAnimationsModule,
        CoreModule,
        CardModule,
        SideNavModule,
        FsProgressModule], providers: [
        {
            provide: ErrorStateMatcher,
            useClass: ShowOnDirtyErrorStateMatcher,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
}
